import { render, staticRenderFns } from "./CaracteristicaEducacao.vue?vue&type=template&id=66e42178"
import script from "./CaracteristicaEducacao.vue?vue&type=script&lang=js"
export * from "./CaracteristicaEducacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports